<app-deprecated-modal-form
    #createReminderModal
    [form]="createReminderForm"
    (save)="onCreate(createReminderForm.reminder, createReminderForm)"
    headerText="employees.settingsOffboarding.addReminder"
>
    <app-form-offboarding-reminder #createReminderForm></app-form-offboarding-reminder>
</app-deprecated-modal-form>

<app-deprecated-modal-form
    #editReminderModal
    [form]="editReminderForm"
    (save)="onSave(editReminderForm.reminder, editReminderForm)"
    headerText="employees.settingsOffboarding.editReminder"
>
    <app-form-offboarding-reminder #editReminderForm></app-form-offboarding-reminder>
</app-deprecated-modal-form>

<app-deprecated-confirmation-dialog
    #confirmationDialog
    label="delete"
    [negative]="true"
></app-deprecated-confirmation-dialog>

<div class="page-container" [class.loading]="isLoading">
    <app-header
        title="{{ 'employees.settingsOffboarding.people' | translate }}"
        [menuService]="employeeModuleMenuService"
    >
        <div class="buttons">
            <ui-button type="primary" (click)="createReminderModal.show()">
                <mat-icon svgIcon="plus"></mat-icon
                >{{ 'employees.settingsOffboarding.createOffboardingReminder' | translate }}
            </ui-button>
        </div>
    </app-header>

    <div class="ui table segment">
        <app-segment-header
            title="{{ 'employees.settingsOffboarding.offboardingReminders' | translate }}"
        ></app-segment-header>

        <app-table
            [table]="table"
            (menuItemSelected)="menuAction($event)"
            [useStickyHeader]="false"
            [embedded]="true"
            [showOffset]="false"
        >
            <app-empty-state label="employees.settingsOffboarding.noOffboardingReminders"></app-empty-state>
        </app-table>
    </div>
</div>
